import { API_BASE } from "config/api";
import { withAuthHeaders } from "services/authHeader";

export async function getCountries() {
  try {
    let url = new URL("api/sdb/getCountries", API_BASE);
    let result = await fetch(url, {
      method: "GET",
      headers: withAuthHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    });
    result = await result.json();
    if (result.status == "success") {
      return result.data;
    }
  } catch (error) {
    console.error("Error in getStates:", error);
    throw error; // Rethrow to be caught in fetchDropdownData
  }
}

/* fetch states */
export async function getStates(country) {
  try {
    let url = new URL("api/sdb/getStates", API_BASE);
    url.searchParams.set("country", country || "");
    let result = await fetch(url, {
      method: "GET",
      headers: withAuthHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    });
    result = await result.json();
    if (result.status == "success") {
      return result.data;
    }
  } catch (error) {
    console.error("Error in getStates:", error);
    throw error; // Rethrow to be caught in fetchDropdownData
  }
}

/* district api call pass state*/
export async function getDistricts(state) {
  try {
    let url = new URL("api/sdb/getDistricts", API_BASE);
    url.searchParams.set("state", state || "");
    let result = await fetch(url, {
      method: "GET",
      headers: withAuthHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    });
    result = await result.json();
    if (result.status == "success") {
      return result.data;
    }
  } catch (error) {
    console.error("Error in getDistricts:", error);
    throw error; // Rethrow to be caught in fetchDropdownData
  }
}
/* blocks api call pass state and district*/
export async function getBlocks(state, district) {
  try {
    let url = new URL("api/sdb/getBlocks", API_BASE);
    url.searchParams.set("state", state || "");
    url.searchParams.set("district", district || "");

    let result = await fetch(url, {
      method: "GET",
      headers: withAuthHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    });
    result = await result.json();
    if (result.status == "success") {
      return result.data;
    }
  } catch (error) {
    console.error("Error in getBlocks:", error);
    throw error; // Rethrow to be caught in fetchDropdownData
  }
}
/* program api call */
export async function getPrograms() {
  try {
    let url = new URL("api/programs/getPrograms", API_BASE);
    let result = await fetch(url, {
      method: "GET",
      headers: withAuthHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    });
    result = await result.json();
    if (result.status == "success") {
      return result.data;
    }
  } catch (error) {
    console.error("Error in getPrograms:", error);
    throw error; // Rethrow to be caught in fetchDropdownData
  }
}
